module.exports = __webpack_public_path__ + "img/bootstrap.46e17dcc.svg";